import styled from 'styled-components';

const Textarea = styled('textarea')`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray_300};
  border-radius: 4px;
  padding: 8px 10px;
  outline: none;
  resize: none;

  ${({ theme: { mediaQueries, fontSizes } }) => {
    return `
      font-size: ${fontSizes[0]};

      ${mediaQueries.desktop} {
        font-size: ${fontSizes[1]};
      }
    `;
  }}
`;

export default Textarea;
